import * as React from 'react';
import { observer } from 'mobx-react';
import AjtApp, { AppHeader, AppRoutes, AppRoute } from 'ajt-app';
import theme from './config/theme';
import ImgMapa from '@material-ui/icons/Place';
import ImgFitxUrb from '@material-ui/icons/LayersRounded';
import ImgLlic from '@material-ui/icons/PinDrop';
import AppState from './states/AppState';
import PantGuia from './pantalles/PantGuia';
import PantGuiaI from './pantalles/PantGuiaI';
import PantFitxUrb from './pantalles/PantFitxUrb';
import PantLlic from './pantalles/PantLlic';
import PantMapa from './pantalles/PantMapa';
import PantMapaI from './pantalles/PantMapaI';
import PantMapa40 from './pantalles/PantMapa40';
import PantMapaGRSMM from './pantalles/PantMapaGRSMM';

const appState = new AppState();

@observer
class App extends React.Component<unknown, unknown> {
    render() {
        if (!appState) {
            return null;
        }
        // A les pantalles MapaI i MapaIWH no hi volem capçalera
        // const app = true;
        const app: boolean = (window.location.href.toLowerCase().lastIndexOf('mapai') <= 0 && window.location.href.toLowerCase().lastIndexOf('guiai') <= 0);
        return (
            <AjtApp appState={appState} theme={theme}>
                {app && <AppHeader />}
                <AppRoutes marginHead={app ? 0 : 0} >
                    <AppRoute nom="Guia" label="Mapa guia" path="/guia" icon={ImgMapa} component={PantGuia} />
                    <AppRoute nom="GuiaI" label="Mapa" path="/guiai" exact={true} icon={ImgMapa} component={PantGuiaI} />
                    <AppRoute nom="GuiaIWH" label="Mapa" path="/guiai/:width/:height" icon={ImgMapa} component={PantGuiaI} />
                    <AppRoute nom="FitxUrb" label="Fitxa urbanística" path="/fitxurb" icon={ImgFitxUrb} component={PantFitxUrb} />
                    <AppRoute nom="LLics" label="Llicències" path="/llicencies" icon={ImgLlic} component={PantLlic} />
                    <AppRoute nom="Mapa" label="Mapa de Manresa" path="/mapa/:conf" icon={ImgMapa} component={PantMapa} />
                    <AppRoute nom="MapaI" label="Definir la posició" path="/mapai/:conf" exact={true} icon={ImgMapa} component={PantMapaI} />
                    <AppRoute nom="MapaIWH" label="Definir la posició" path="/mapai/:conf/:width/:height" icon={ImgMapa} component={PantMapaI} />
                    <AppRoute nom="Mapa40" label="Mapa virtual de l'ecosistema 4.0 al Bages" path="/mapa40" icon={ImgMapa} component={PantMapa40} />
                    <AppRoute nom="MapaGRSMM" label="Guia de recursos de salut mental a Manresa" path="/mapagrsmm" icon={ImgMapa} component={PantMapaGRSMM} />
                    <AppRoute nom="Error" label="Falta la ruta" icon={ImgMapa} />
                </AppRoutes>
            </AjtApp>
        );
    }
}

export default App;
